// extracted by mini-css-extract-plugin
export default {"marginbottom":"StatMeasurement_marginbottom__zE4HM"};